export default "__VITE_ASSET__c9242713__"